import PageProductPublic from '@/pages/PageProductPublic'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: PageProductPublic
	}

	let page = vuewidget(dom, options)
	return page
}